"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const cdn_1 = require("./utils/cdn");
class ImageTagsServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    generateTags({ imageUrl, customTags, isAiGenerated, aiModel }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!imageUrl) {
                throw new client_library_1.MissingParamError('imageUrl');
            }
            return yield this._makeImageRequest('api/tags/generate', 'POST', {
                imageUrl,
                customTags,
                isAiGenerated,
                aiModel
            }, undefined, [201]);
        });
    }
    teacherGenerateTags({ imageUrl, customTags }) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._makeImageRequest('api/tags/teacher/generate', 'POST', { imageUrl, customTags }, undefined, [201]);
        });
    }
    searchAllTags(query) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!query) {
                throw new client_library_1.MissingParamError('query');
            }
            let items = [];
            let from = undefined;
            do {
                const page = yield this.searchPageOfTags(query, { from });
                from = page.next;
                items = items.concat(page.items);
            } while (from);
            return {
                items,
                total: items.length
            };
        });
    }
    searchPageOfTags(query, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const path = 'api/tags/search';
            return this._makeSearchPageOfTags(path, query, options);
        });
    }
    teacherSearchPageOfTags(query, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const path = 'api/tags/teacher/search';
            return this._makeSearchPageOfTags(path, query, options);
        });
    }
    teacherFetchPageOfTags(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const path = 'api/tags/teacher/fetch';
            const response = yield this._makeImageRequest(path, 'GET', undefined, {
                limit: options && options.limit,
                from: options && options.from
            });
            response.items = response.items.map((item) => {
                item.imageUrl = cdn_1.getCdnUrl(item.imageUrl);
                return item;
            });
            return response;
        });
    }
    _makeSearchPageOfTags(path, query, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this._makeImageRequest(path, 'GET', undefined, {
                query,
                limit: options && options.limit,
                from: options && options.from
            });
            response.items = response.items.map((item) => {
                item.imageUrl = cdn_1.getCdnUrl(item.imageUrl);
                return item;
            });
            return response;
        });
    }
    _makeImageRequest(path, method, body, queryParams, expectedResponses) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = `${this.url}/${path}`;
            if (queryParams) {
                let queryParamParts = [];
                Object.keys(queryParams).forEach(param => {
                    if (queryParams[param]) {
                        queryParamParts.push(`${param}=${queryParams[param]}`);
                    }
                });
                url += `?${queryParamParts.join('&')}`;
            }
            const response = yield this.requestMaker.makeRequest(url, {
                method: method,
                body: body ? JSON.stringify(body) : undefined
            }, expectedResponses);
            return response.json;
        });
    }
}
exports.default = ImageTagsServiceClient;
